import { styled, Tab, Tabs } from '@mui/material';

import { FF_PHARMACIST_STOCKTAKE_IN_PORTAL } from '@/constants/featureFlags';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { tabs } from '@/pages/inventory/PharmacistInventory';

const PharmacistInventoryTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontFamily: theme.typography.button.fontFamily,
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: 'auto',
  },
}));

interface IPharmacistInventoryTabsProps {
  activeTab: string;
  toggleTab: (tab: string) => void;
}

function PharmacistInventoryTabs({ activeTab, toggleTab }: IPharmacistInventoryTabsProps) {
  const showStocktake = useFeatureFlag(FF_PHARMACIST_STOCKTAKE_IN_PORTAL);
  const stocktake = showStocktake ? <PharmacistInventoryTab label="Stocktake" value={tabs.STOCKTAKE} /> : null;
  return (
    <Tabs
      value={activeTab}
      onChange={(_event, newView) => toggleTab(newView)}
      textColor="secondary"
      indicatorColor="secondary"
    >
      <PharmacistInventoryTab label="Product Overview" value={tabs.PRODUCT_OVERVIEW} />
      <PharmacistInventoryTab label="Adjustment Overview" value={tabs.ADJUSTMENT_OVERVIEW} />
      {stocktake}
    </Tabs>
  );
}

export default PharmacistInventoryTabs;
